export default String.raw`
{% if cart.Changes -%}
    <div class="cart__popup cart-popup-js recalculate-js">
        <div class="cart__popup-box recalculate">
            {% assign mustChangeCountry = false -%}
            {% for cartChangeInfo in cart.Changes -%}
                {% if cartChangeInfo.Id == 9 -%}
                    {% assign mustChangeCountry = true -%}
                    {% break -%}
                {% endif -%}
            {% endfor -%}
            <div class="cart__popup-header">
                <div class="cart__popup-title">
                    <svg class="warning-icon">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#exclamation-triangle-{{settings.iconStyle}}"></use>
                    </svg>
                    <span>{{ translations.CartWillRecalculate }}</span>
                </div>
                {% unless mustChangeCountry -%}
                    <svg tabindex="0" role="button" aria-label="{{ translations.Close }}" class="cart__popup-closer cart-popup-closer-js">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
                    </svg>
                {% endunless -%}
            </div>
            <div class="cart__popup-content">
                <div>{{ translations.CartChangesInfo }}</div>
                <ul class="cart__popup-list">
                    {% for cartChangeInfo in cart.Changes -%}
                        <li>{{ cartChangeInfo.Text }}</li>
                    {% endfor -%}
                </ul>
                <br/>
                {% assign countriesSize = config.Countries | Size -%}
                {% if mustChangeCountry and countriesSize > 1 -%}
                    <div>{{ translations.ChangeCountryRecalculateInfo }}</div>
                    <br/>
                    <div class="form__input-wrapper">
                        <span class="form__input-info input-info-js">{{ translations.Country }}</span>
                        <div class="cart__select select-wcag-js">
                            {% assign selectedCountry = "" -%}
                            {% for country in config.Countries -%}
                                {% if country.ISOCode == cart.Customer.DeliveryAddress.Country -%}
                                    {% assign selectedCountry = country -%}
                                    {% break -%}
                                {% endif -%} 
                            {% endfor -%}
                            <input type="hidden" 
                                name="countryCode" 
                                class="input-value-js cart-select-value-js"
                                data-country="{{ selectedCountry.ISOCode }}"
                                value="{{ selectedCountry.ISOCode }}" 
                            />
                            <div role="button" tabindex="0" class="cart__select-value form__input-value cart-select-js">
                                <span class="cart-select-text-js">{{ config.Countries[selectedCountry.ISOCode].Name }}</span>
                                <div class="cart__select-arrow cart-select-arrow-js">
                                    <svg>
                                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
                                    </svg>
                                </div>
                            </div>
                            <ul class="cart__select-list cart-select-list-js dropdown-js hidden-js">
                                {% for country in config.Countries -%}
                                    <li 
                                        tabindex="-1"
                                        class="cart__select-item"
                                        data-value="{{ country.ISOCode }}" 
                                        data-name="{{ config.Countries[country.ISOCode].Name }}"
                                        >
                                            {{ config.Countries[country.ISOCode].Name }}
                                    </li>
                                {% endfor -%}
                            </ul>
                        </div>  
                        <div class="form__invalid-input validation-required-js hidden-js">{{ translations.ChangeCountry }}</div>
                    </div>
                {% else -%}
                    <div>{{ translations.ClickRecalculateInfo }}</div>
                {% endif -%}
                <button class="primary-action-button cart__popup-recalculate recalculate-cart-js {% if mustChangeCountry and countriesSize > 1 -%} recalculate-change-country-js {% endif -%}">
                    {{ translations.RecalculateOrder }}
                    <svg class="right-icon">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#sync-{{settings.iconStyle}}"></use>
                    </svg>
                </button>
            </div>
        </div>
    </div>
{% endif -%}

<div class="cart__products products-table-js">
    {% include 'partials/cart/products-partials/product-table-header.html' -%}

    {% assign wasParent = null -%}

    {% assign productsOnPage = 9 -%}

    {% assign pageNumber = include -%}
    {% assign startingProductIndex = pageNumber | Times:productsOnPage | Minus:productsOnPage  -%}

    {% assign isSetElement = false -%}
    {% assign productsOnCartPage = 0 -%}
    {% for product in cart.Products -%}
        {% if forloop.index0 < startingProductIndex -%}
            {% continue -%}
        {% endif -%}
        {% assign nextIndex = forloop.index -%}
        {% assign nextEl = null -%}
        {% for productItem in cart.Products -%}
            {% if forloop.index0 == nextIndex -%}
                {% assign nextEl = productItem -%}
                {% break -%}
            {% endif -%}
        {% endfor -%}
        {% assign isDiscount = true -%}
        {% if product.Discount == 0 or settings.discountsPresentationOnOrderPositions == 'no' -%}
            {% assign isDiscount = false -%}
        {% endif -%}
        {% if product.IsSetElement -%}
            {% assign isSetElement = true -%}
        {% endif -%}
        {% if product.IsSetParent -%}
            {% assign wasParent = true -%}
            <div class="expandable-mechanism-container-js" data-product-no="{{product.No}}">
                <div>
                    {% include 'partials/cart/products-partials/set-aggregator.html' with product.No -%}
                </div>
                <div class="cart__products-expanded expandable-js {% if product.AskForPrice and cart.OrderStep == 'Start' -%} expanded-js {% endif -%}">
        {% endif -%}
                    <div class="expandable-mechanism-container-js cart-product-container-js {% if product.IsSetElement -%} set-element-js {% endif -%}"
                        data-product-no="{{product.No}}"
                        data-product-id="{{product.Id}}"
                        data-product-price="{% if config.ENTERPRISE -%}{{product.TotalPrice}}{% else -%}{{product.Price}}{% endif -%}">
                        {% include 'partials/cart/products-partials/product.html' with product.No -%}
                    </div>
        {% if product.IsSetElement and wasParent and (nextEl == null or nextEl.IsSetElement == false or nextEl.IsSetParent) -%}
                    {% assign wasParent = false -%}
                </div>
            </div>
        {% endif -%}
        {% if product.IsSetParent == false and product.IsSetElement -%}
            {% continue -%}
        {% endif -%}
        {% assign productsOnCartPage = productsOnCartPage | Plus: 1 -%}
        {% if productsOnCartPage >= productsOnPage -%}
            {% break -%}
        {% endif -%}
    {% endfor -%}
            
    {% assign productsSize = 0 -%}
    {% for cartItem in cart.Products -%}
        {% if cartItem.IsSetParent == false and cartItem.IsSetElement -%}
            {% continue -%}
        {% endif -%}
        {% assign productsSize = productsSize | Plus: 1 -%}
    {% endfor -%}
    {% assign paginationPageCount = productsSize | DividedBy: productsOnPage -%}
    {% assign productsModulo = productsSize | Modulo: productsOnPage -%}

    {% if productsModulo != 0 -%}
        {% assign paginationPageCount = paginationPageCount | Plus: 1 -%}
    {% endif -%}

    <div class="cart__products-footer">
        {% assign paginationPageNo = pageNumber -%}
        {% assign template = 'partials/cart/products-partials/products.html' -%}
        {% assign templateContainer = '.cart-products-container-js' -%}

        {% if paginationPageCount > 1 -%}
            {% capture url -%}{{page.Url}}{% endcapture -%}
            {% capture urlFirstPage -%}{{url}}{% endcapture -%}
            {% if url contains '?' -%}
                {% capture url -%}{{url}}&page={% endcapture -%}
            {% else -%}
                {% capture url -%}{{url}}?page={% endcapture -%}
            {% endif -%}

            {% assign prevPage = paginationPageNo | Minus: 1 %}
            {% assign nextPage = paginationPageNo | Plus: 1 %}
            {% assign paginationStart = paginationPageNo | Minus: 1 %}
            {% assign paginationEnd = paginationPageNo | Plus: 1 %}
            {% assign paginationLessPages = paginationPageNo | Plus: 1 %}
            {% assign paginationMorePages = paginationPageNo | Plus: 2 %}

            {% if paginationPageNo == 1 %}
                {% assign paginationStart = 1 %}
                {% assign paginationEnd = 3 %}
            {% endif %}

            {% if paginationPageNo == paginationPageCount %}
                {% assign paginationStart = paginationPageCount | Minus: 2 %}
                {% assign paginationEnd = paginationPageCount %}
            {% endif %}

            <div class="pagination-form-js pagination pagination-js" data-template="{{ template }}" data-container="{{ templateContainer }}">  
                <button aria-label="{{ translations.Prev }}" type="button" class="change-quantity-button {% unless paginationPageNo == 1 -%} pagination-in-cart-js {% endunless -%}" data-url="{{ url | H }}{{ prevPage }}" data-page="{{ prevPage }}" {% if paginationPageNo == 1 %} disabled {% endif %}>
                    <svg width="12" height="12" class="svgIcon" style="transform: rotate(180deg); margin-right: 12px">
                        <use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-regular"></use>
                    </svg>
                    {{ translations.Prev }}
                </button>
                <div>
                    <button type="button" class="change-quantity {% if paginationPageNo == 1 %} change-quantity__active {% endif %} pagination-in-cart-js" data-url="{{ url | H }}1" data-page="1" {% if paginationPageNo == 1 %} disabled {% endif %}>
                    1
                    </button>
                </div>
                {% if paginationStart > 2 %}
                    <div>...</div>
                {% endif %}
                {% for i in (paginationStart..paginationEnd) %}
                    {% if i > 1 and i < paginationPageCount %}
                    <div>
                        <button type="button" class="change-quantity {% if paginationPageNo == i %} change-quantity__active {% endif %} pagination-in-cart-js" data-url="{{ url | H }}{{ i }}" data-page="{{ i }}" {% if paginationPageNo == i %} disabled {% endif %}>
                            {{ i }}
                        </button>
                    </div>
                    {% endif %}
                {% endfor %}
                {% if paginationPageCount < 5 -%}
                    {% if paginationlessPages < paginationPageCount -%}
                    <div>...</div>
                    {% endif -%}
                {% else -%}
                    {% if paginationMorePages < paginationPageCount -%}
                    <div>...</div>
                    {% endif -%}
                {% endif -%}
                <div>
                    <button type="button" class="change-quantity {% if paginationPageNo == paginationPageCount %} change-quantity__active {% endif %} pagination-in-cart-js" data-url="{{ url | H }}{{ paginationPageCount }}" data-page="{{ paginationPageCount }}" {% if paginationPageNo == paginationPageCount %} disabled {% endif %}>
                        {{ paginationPageCount }}
                    </button>
                </div>
                <button aria-label="{{ translations.Next }}" type="button" class="change-quantity-button {% unless paginationPageNo == paginationPageCount -%} pagination-in-cart-js {% endunless -%}" data-url="{{ url | H }}{{ nextPage }}" data-page="{{ nextPage }}" {% if paginationPageNo == paginationPageCount %} disabled {% endif %}>
                    {{ translations.Next }}
                    <svg width="12" height="12" class="svgIcon" style="margin-left: 12px">
                        <use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-regular"></use>
                    </svg>
                </button>
            </div>
        {% endif -%}
    </div>
</div>

{% assign showLoader = false -%}
{% if isSetElement -%}
    {% assign showLoader = true -%}
{% endif -%}

{% if showLoader -%}
    <div class="during-ajax-modal-js during-ajax-modal hidden-js">
        <div class="loader big"></div>
    </div>
{% endif -%}
`